/**
 * @generated SignedSource<<4e5f86dbcfb4db2bdfe56f1e77da0192>>
 * @relayHash f48350f3a958d8922e65054af780d7d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c5d18f6e4abdc2353c05e9d6b81a47bd45d06d502ec7889f2590c1126ec98aa1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PolarisGlobalViewsSettingsDetailsPageQuery } from './PolarisGlobalViewsSettingsDetailsPageQuery.graphql';

const node: PreloadableConcreteRequest<PolarisGlobalViewsSettingsDetailsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c5d18f6e4abdc2353c05e9d6b81a47bd45d06d502ec7889f2590c1126ec98aa1",
    "metadata": {},
    "name": "PolarisGlobalViewsSettingsDetailsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
